import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { Skeleton } from '@/components/ui/skeleton';
import { Badge } from '@/components/ui/badge';
import { Phone, Trophy } from 'lucide-react';
import { useFunnelConversionBySDR, type FunnelFilters } from '@/hooks/useFunnelMetrics';

interface Props {
  filters: FunnelFilters;
}

export default function FunnelConversionBySDR({ filters }: Props) {
  const { data, isLoading } = useFunnelConversionBySDR(filters);

  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Phone className="h-5 w-5" />
            Conversão por SDR
          </CardTitle>
        </CardHeader>
        <CardContent>
          <Skeleton className="h-48 w-full" />
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Phone className="h-5 w-5" />
          Conversão por SDR
        </CardTitle>
      </CardHeader>
      <CardContent>
        {!data || data.length === 0 ? (
          <p className="text-muted-foreground text-center py-4">Sem dados para o período (mínimo 5 leads)</p>
        ) : (
          <div className="overflow-auto">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>SDR</TableHead>
                  <TableHead className="text-right">Leads</TableHead>
                  <TableHead className="text-right">Contatou</TableHead>
                  <TableHead className="text-right">Agendou</TableHead>
                  <TableHead className="text-right">Taxa Contato</TableHead>
                  <TableHead className="text-right">Taxa Agendamento</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {data.map((row, index) => (
                  <TableRow key={row.sdr_id || `sdr-${index}`} className={index < 3 ? 'bg-blue-50/50 dark:bg-blue-950/20' : ''}>
                    <TableCell className="font-medium">
                      <div className="flex items-center gap-2">
                        {index < 3 && <Trophy className="h-4 w-4 text-yellow-500" />}
                        {row.sdr_name}
                      </div>
                    </TableCell>
                    <TableCell className="text-right">{row.total_leads}</TableCell>
                    <TableCell className="text-right">{row.contacted}</TableCell>
                    <TableCell className="text-right text-green-600 font-medium">{row.scheduled}</TableCell>
                    <TableCell className="text-right">
                      <Badge variant="outline">
                        {row.contact_rate?.toFixed(1) || 0}%
                      </Badge>
                    </TableCell>
                    <TableCell className="text-right">
                      <Badge 
                        variant={row.schedule_rate >= 30 ? 'default' : row.schedule_rate >= 20 ? 'secondary' : 'outline'}
                        className={row.schedule_rate >= 30 ? 'bg-green-500' : ''}
                      >
                        {row.schedule_rate?.toFixed(1) || 0}%
                      </Badge>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
